import { render, staticRenderFns, recyclableRender, components } from "./mine.vue?vue&type=template&id=567495f9&scoped=true&"
var renderjs
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&id=567495f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567495f9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/mine/mine.vue"
export default component.exports